module.exports = __webpack_public_path__ + "img/goodness-25.072318f6.png";